var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"presskit-banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12\"\u003E\u003Ch2\u003E Need some assets? \u003Ca href=\"https:\u002F\u002Fcdn2.auth0.com\u002Fwebsite\u002Fauth0-assets-press-kit.zip\" download target=\"_blank\" rel=\"noopener noreferrer\"\u003EDownload Press Kit\u003C\u002Fa\u003E\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/press/includes/section-mediakit-banner.pug
// module id = 971
// module chunks = 0